// This file is a fork of gatsby-cookie-notice found here: https://github.com/florent6001/gatsby-cookie-notice
// The change we made to this is simply to remove it's connection with gatsby-plugin-gdpr-cookies via `initializeAndTrack`
// and replace it with onAccept and onDecline callback functions that can be used generally.

import React, { useEffect, useState } from 'react'

interface Cookie {
  name: string
  editable: boolean
  default: boolean
  title?: string
  text?: string
}

interface CookieNoticeProps {
  children: React.ReactNode
  backgroundClasses?: string
  backgroundWrapperClasses?: string
  acceptButtonText?: string
  acceptButtonClasses?: string
  buttonWrapperClasses?: string
  declineButton?: boolean
  declineButtonClasses?: string
  declineButtonText?: string
  wrapperClasses?: string
  personalizeButtonClasses?: string
  personalizeButtonText?: string
  cookies: Cookie[]
  cookieDays?: number
  personalizeButtonEnable: boolean
  cookieListClasses?: string
  cookieMapClasses?: string
  cookieTitleClasses?: string
  personalizeValidationClasses?: string
  personalizeValidationWrapperClasses?: string
  personalizeValidationText?: string
  onAccept?: () => void
  onDecline?: () => void
}

const CookieNotice: React.FC<CookieNoticeProps> = ({
  children,
  backgroundClasses = 'container',
  backgroundWrapperClasses = 'bg-cookie fixed-bottom py-5',
  acceptButtonText = 'Accept',
  buttonWrapperClasses = 'float-end',
  acceptButtonClasses = 'btn btn-primary btn-lg mx-2',
  declineButton = true,
  declineButtonText = 'Decline',
  declineButtonClasses = 'btn btn-secondary btn-lg mx-2',
  wrapperClasses = 'd-flex justify-content-between cookie-notice',
  personalizeButtonClasses = 'btn btn-secondary',
  personalizeButtonText = 'Personalize',
  cookies,
  cookieDays = 365,
  personalizeButtonEnable = true,
  cookieListClasses = 'row cookie-list',
  cookieMapClasses = 'col-12 col-md-6',
  cookieTitleClasses = '',
  personalizeValidationClasses = 'btn btn-primary btn-lg float-end',
  personalizeValidationWrapperClasses = 'col-12',
  personalizeValidationText = 'Save',
  onAccept,
  onDecline,
}: CookieNoticeProps) => {
  const [displayCookieList, setDisplayCookieList] = useState<
    boolean | undefined
  >()
  const [displayCookieNotice, setDisplayCookieNotice] = useState<
    boolean | undefined
  >()

  const styles = {
    background: backgroundClasses,
    backgroundWrapper: backgroundWrapperClasses,
    acceptBtn: acceptButtonClasses,
    buttonWrapper: buttonWrapperClasses,
    declineBtn: declineButtonClasses,
    wrapper: wrapperClasses,
    personalizeButton: personalizeButtonClasses,
    cookiesList: cookieListClasses,
    cookieMap: cookieMapClasses,
    cookieTitle: cookieTitleClasses,
    personalizeValidation: personalizeValidationClasses,
    personalizeValidationWrapper: personalizeValidationWrapperClasses,
  }

  const text = {
    acceptButton: acceptButtonText,
    declineButton: declineButtonText,
    personalizeButton: personalizeButtonText,
    personalizeValidation: personalizeValidationText,
  }

  const prop = {
    declineButtonActivated: declineButton,
    cookiesList: cookies,
    cookieDays: cookieDays,
    personalizeButton: personalizeButtonEnable,
  }

  const date = new Date()
  date.setTime(date.getTime() + prop.cookieDays * 24 * 60 * 60 * 1000)
  const expires = '; expires=' + date.toUTCString()

  const acceptCookie = () => {
    prop.cookiesList.map((c) => {
      return (document.cookie = c.name + '=true' + expires + '; path=/')
    })

    // Add onAccept callback.
    if (onAccept) {
      onAccept()
    }

    setDisplayCookieNotice(false)
  }

  const declineCookie = () => {
    prop.cookiesList.map((c) => {
      if (c.editable)
        return (document.cookie = c.name + '=false' + expires + '; path=/')
      else
        return (document.cookie =
          c.name + '=' + c.default + expires + '; path=/')
    })

    // Add onDecline callback.
    if (onDecline) {
      onDecline()
    }

    setDisplayCookieNotice(false)
  }

  const validatePreferences = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    prop.cookiesList.map((c) => {
      const checkbox = document.getElementById(c.name) as HTMLInputElement
      if (checkbox && checkbox.checked) {
        document.cookie = c.name + '=true' + expires + '; path=/'
      } else {
        document.cookie = c.name + '=false' + expires + '; path=/'
      }
      setDisplayCookieNotice(false)
    })
  }

  const cookieExist = (name: string) => {
    const dc = document.cookie
    const prefix = name + '='
    let begin = dc.indexOf('; ' + prefix)
    if (begin === -1) {
      begin = dc.indexOf(prefix)
      if (begin !== -1) {
        let end = document.cookie.indexOf(';', begin)
        if (end === -1) {
          end = dc.length
        }
        return decodeURI(dc.substring(begin + prefix.length, end))
      }
    } else {
      begin += 2
      let end = document.cookie.indexOf(';', begin)
      if (end === -1) {
        end = dc.length
      }
      return decodeURI(dc.substring(begin + prefix.length, end))
    }
    return null
  }

  useEffect(() => {
    prop.cookiesList.map((c) => {
      if (!cookieExist(c.name)) {
        return setDisplayCookieNotice(true)
      }
    })
  })

  return (
    <>
      {displayCookieNotice && (
        <div className={styles.backgroundWrapper}>
          <div className={styles.background}>
            {children}
            {displayCookieList && (
              <form onSubmit={validatePreferences}>
                <div className={styles.cookiesList}>
                  {prop.cookiesList.map((c) => {
                    return (
                      <div key={c.name} className={styles.cookieMap}>
                        <input
                          type="checkbox"
                          defaultChecked={c.default}
                          disabled={!c.editable}
                          value={c.name}
                          id={c.name}
                        />
                        <label htmlFor={c.name} className={styles.cookieTitle}>
                          {c.title}
                        </label>
                        <p>{c.text}</p>
                      </div>
                    )
                  })}
                  <div className={styles.personalizeValidationWrapper}>
                    <button
                      type={'submit'}
                      className={styles.personalizeValidation}
                    >
                      {text.personalizeValidation}
                    </button>
                  </div>
                </div>
              </form>
            )}
            {!displayCookieList && (
              <div className={styles.wrapper}>
                {prop.personalizeButton && (
                  <button
                    onClick={() => setDisplayCookieList(true)}
                    className={styles.personalizeButton}
                  >
                    {text.personalizeButton}
                  </button>
                )}
                <div className={styles.buttonWrapper}>
                  {prop.declineButtonActivated && (
                    <button
                      onClick={declineCookie}
                      className={styles.declineBtn}
                    >
                      {text.declineButton}
                    </button>
                  )}
                  <button onClick={acceptCookie} className={styles.acceptBtn}>
                    {text.acceptButton}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default CookieNotice
